import React from "react";
import Box from "@mui/material/Box";
import { useAppSelector } from "../../../framework/customStore";
import { SectionHeader } from "../../layout/sectionHeader";
import { MonitorViewWorkShifts } from "./monitorViewWorkShifts";
import { MonitorViewSidebarProps } from "../../../models/monitorView/monitorViewTypes";
import SidebarHeader from "./sidebarHeader";
import { MonitorViewVehicle } from "./monitorViewVehicle";
import { MonitorViewOverviewSidebar } from "./monitorViewOverviewSidebar";

export const MonitorViewSidebar = ({
    fleetSummaryTotals,
    vehiclesAndEmployeesSidebarProps
}: MonitorViewSidebarProps) => {

    const sidebarTitle = useAppSelector(
        (state) => state.monitorView.sidebarTitle
    );
    const isWorkShiftView = useAppSelector(
        (state) => state.monitorView.isWorkShiftView
    );
    const isVehicleDetailView = useAppSelector(
        (state) => state.monitorView.isVehicleDetailView
    );

    return (
        <Box width={375} height="100%" display="flex" flexDirection="column">
            <SectionHeader>
                <SidebarHeader
                    header={sidebarTitle}
                    fleetSummaryTotals={fleetSummaryTotals}
                />
            </SectionHeader>

            <Box sx={{ flex: 1, minHeight: 0, paddingTop: 1, display: "flex", flexDirection: "column" }}>
                {isWorkShiftView ? (
                    <Box sx={{ overflowY: "auto", flex: 1 }}>
                        <MonitorViewWorkShifts
                            transportOrders={vehiclesAndEmployeesSidebarProps.transportOrders}
                        />
                    </Box>
                ) : isVehicleDetailView ? (
                    <Box sx={{ overflowY: "auto", flex: 1 }}>
                        <MonitorViewVehicle
                            transportOrders={vehiclesAndEmployeesSidebarProps.transportOrders}
                        />
                    </Box>
                ) : (
                    <MonitorViewOverviewSidebar
                        {...vehiclesAndEmployeesSidebarProps}
                        fleetSummaryTotals={fleetSummaryTotals}
                    />
                )}
            </Box>
        </Box>
    );
};
